import React, { useContext, useState } from "react";
import "./style.scss";
import Button from "../../../common/Button";
import nextIcon from "../../../assets/AddSubCategory/nextIcon.svg";
import { useNavigate, useParams } from "react-router-dom";
import { useGetlistCategories, useGetlistSubCategories, useGetSkuDetail, useLogoutUser } from "../../../hooks/useSeggregation";
import {
  useGetAllCategorises,
  useGetAllSubCategorises,
} from "../../../hooks/useGuidelines";
import { Select } from "antd";
import { SeggreagtionContext } from "../../../context/seggregationProvider";

const AddSubCategory = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [skuFiles, setSkuFiles] = useState([]);
  const [categoriesList, setCategoriesList] = useState([]);
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [skuCategoryList, setSkuCategoryList] = useState([]);
  const [skuSubCategoryList, setSkuSubCategoryList] = useState([]);
  const [filterCategoryList, setFilterCategoryList] = useState([]);
  const [filterSubCategoryList, setFilterSubCategoryList] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState("");
  const [selectedSubCategoryId, setSelectedSubCategoryId] = useState("");
  const {
    segg_selectedCategory,
    segg_setSelectedCategory,
    segg_selectedSubCategory,
    segg_setSelectedSubCategory,
    segg_queryParams,
  } = useContext(SeggreagtionContext);

  const onSuccessGetSkuDetails = (res) => {
    if (res.status === 200) {
      setSkuFiles(res.data.skuFiles);
    }
  };
  const onErrorGetSkuDetails = (err) => {
    console.log(err);
  };
  const { data: getSkuDetails } = useGetSkuDetail(
    "getSKudetails",
    params?.skuId,
    onSuccessGetSkuDetails,
    onErrorGetSkuDetails
  );
  // const onSuccessGetAllCategories = (res) => {
  //   if (res?.status === 200) {
  //     setCategoriesList(res.data.data);
  //     setFilterCategoryList(res.data.data);
  //   }
  // };
  // const onErrorGetAllCategories = () => {};
  // const { data: getCategories, refetch: refetchListCategories } =
  //   useGetAllCategorises(
  //     "getAllCategories",
  //     1,
  //     9999,
  //     "",
  //     onSuccessGetAllCategories,
  //     onErrorGetAllCategories
  //   );

  // const onSuccessGetAllSubCategories = (data) => {
  //   if (data?.status === 200) {
  //     setSubCategoryList(data?.data?.data);
  //     setFilterSubCategoryList(data?.data?.data);
  //   }
  // };

  // const onErrorGetAllSubCategories = (err) => {
  //   console.log(err.message);
  // };

  // const { data: getAllSubCategories, refetch: refetchSubCategories } =
  //   useGetAllSubCategorises(
  //     "getAllSubCategories",
  //     segg_selectedCategory?.id,
  //     1,
  //     99999,
  //     "",
  //     onSuccessGetAllSubCategories,
  //     onErrorGetAllSubCategories
  //   );


    const onSuccessGetListCategories = (res) => {
      if (res?.status === 200) {
        console.log(res?.data?.data);
        setSkuCategoryList(res?.data?.data);
        setFilterCategoryList(res?.data?.data);
        // console.log('filter', res?.data?.data);
      }
    };
    const onErrorGetListCategories = () => {};
    const { data: getListCategories, refetch: refetchSkuListCategories } =
    useGetlistCategories(
        "getListCategories",
        params?.skuId,
        onSuccessGetListCategories,
        onErrorGetListCategories
    );


    const onSuccessGetListSubCategories = (data) => {
    if (data?.status === 200) {
      setSkuSubCategoryList(data?.data?.data);
      setFilterSubCategoryList(data?.data?.data);
    }
  };

  const onErrorGetListSubCategories = (err) => {
    console.log(err.message);
  };

  const { data: getlistSubCategories, refetch: refetchSkuSubCategories } =
  useGetlistSubCategories(
      "getlistSubCategories",
      segg_selectedCategory?.id,
      params?.skuId,
      onSuccessGetListSubCategories,
      onErrorGetListSubCategories
    );



  // const onCategorySearch = (value) => {
  //   const filteredCategories = categoriesList.filter((category) =>
  //     category.name.toLowerCase().includes(value.toLowerCase())
  //   );
  //   setFilterCategoryList(filteredCategories);
  // };

  // const onSubCategorySearch = (value) => {
  //   const filteredSubCategories = subCategoryList.filter((subCategory) =>
  //     subCategory.name.toLowerCase().includes(value.toLowerCase())
  //   );
  //   setFilterSubCategoryList(filteredSubCategories);
  // };

const onCategorySearch = (value) => {
    const filteredCategories = skuCategoryList?.filter((category) =>
      category.name.toLowerCase().includes(value.toLowerCase())
    );
    setFilterCategoryList(filteredCategories);
    
  };

  const onSubCategorySearch = (value) => {
    const filteredSubCategories = skuSubCategoryList?.filter((subCategory) =>
      subCategory.name.toLowerCase().includes(value.toLowerCase())
    );
    setFilterSubCategoryList(filteredSubCategories);
  };

  const handleCancel = (e) => {
    e.preventDefault();
    logoutUser({
      draftSkuId: params?.skuId,
    });
  };
  const onSuccessLogout = (res) => {
    if (res.status === 200) {
      if (segg_queryParams.includes("org")) {
        navigate(`/seggregation-batch-list?activeProfile=client`);
      } else {
        navigate(`/seggregation-batch-list?activeProfile=batch`);
      }
    }
  };
  const { mutate: logoutUser } = useLogoutUser(onSuccessLogout);

  return (
    <div className="sub_category_addition">
      <div className="sub_category_wrapper">
        <div className="input_section">
          <div className="box_wrapper">
            {skuFiles.length > 0 &&
              skuFiles.map((skuFile, index) => {
                return (
                  <div className="file_wrapper" key={index}>
                    <img
                      src={skuFile?.image?.thumbPath.url}
                      alt={skuFile?.image?.name}
                    />
                  </div>
                );
              })}
          </div>
        </div>
        <div className="form_category">
          <form>
            <div className="form_control">
              <label>
                Category Name <sup>*</sup>
              </label>
              <Select
                showSearch
                filterOption={false}
                placeholder="Select a category"
                optionFilterProp="label"
                onSearch={onCategorySearch}
                value={segg_selectedCategory?.id}
                onChange={(value) => {
                  const selectedCategory = filterCategoryList.find(
                    (category) => category._id === value
                  );
                  segg_setSelectedCategory({
                    id: value,
                    name: selectedCategory?.name || "",
                  });
                  segg_setSelectedSubCategory({ id: "", name: "" });
                  
                }}
              >
                {filterCategoryList?.length > 0 &&
                  filterCategoryList?.map((category, index) => {
                    return (
                      <Select.Option value={category?._id} key={index}>
                        {category?.name}
                      </Select.Option>
                    );
                  })}
              </Select>
            </div>
            <div className="form_control">
              <label>
                Sub Category Name <sup>*</sup>
              </label>
              <Select
                showSearch
                filterOption={false}
                placeholder="Enter Sub-Category Name"
                name="subCategoryName"
                value={segg_selectedSubCategory?.id || undefined}
                onChange={(value) => {
                  const selectedSubCategory = filterSubCategoryList.find(
                    (subCategory) => subCategory._id === value
                  );
                  segg_setSelectedSubCategory({
                    id: value,
                    name: selectedSubCategory?.name || "",
                  });
                }}
                onSearch={onSubCategorySearch}
              >
                {filterSubCategoryList?.length > 0 &&
                  filterSubCategoryList?.map((subCategory, index) => {
                    return (
                      <Select.Option value={subCategory?._id} key={index}>
                        {subCategory?.name}
                      </Select.Option>
                    );
                  })}
              </Select>
            </div>
            <div className="button_wrapper">
              <button className="cancel_btn" onClick={(e) => handleCancel(e)}>
                Cancel
              </button>
              <Button
                width="195px"
                text="Next"
                height="55px"
                showIcon={true}
                iconImage={nextIcon}
                handleClick={() => navigate(`/select-variant/${params?.skuId}`)}
                isDisabled={!segg_selectedCategory?.id || !segg_selectedSubCategory?.id}
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddSubCategory;
